import React from 'react'
import Header from './Header'
import Footer from './CoachingFooter'
import CoachingBG from '../assets/images/top-bg@3x.png'
import ProgramCategories from "../components/ProgramCategories"
import '../assets/scss/main.scss'


class Layout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isMenuVisible: false,
            loading: 'is-loading',
        }
    }

    componentDidMount() {
        this.timeoutId = setTimeout(() => {
            this.setState({loading: ''})
        }, 100)
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId)
        }
    }

    render() {
        const {children} = this.props;
        return (
            <>
                <div className={`body ${!this.props.noPaddingBottom ?
                    this.props.show120 ?
                        'life-coach-body-120' :
                        'life-coach-body-175' :
                    ''}
        `}>
                    {/*<img className='absoluted-header-image' src={BG}/>*/}
                    <img
                        src={CoachingBG}
                        className='home-bg-img coaching-bg-img'/>


                    <div
                        id='wrapper'
                        className={'coach-wrapper'}
                        style={{paddingBottom: 0}}
                    >
                        <Header show={this.props.show} isLogoWhite={this.props.isLogoWhite}/>
                        {this.props?.categories?.length ?
                            <ProgramCategories
                                categories={this.props?.categories}
                                onSearch={this.props.onSearch}
                                onCategoryChange={this.props.onCategoryChange}
                            /> : null}
                        {children}
                    </div>
                    {/*{this.props.coachingFooter ?*/}
                    {/*<CoachingFooter increaseFooterMargin={this.props.increaseFooterMargin}/>*/}
                    {/*:*/}
                    {/*}*/}

                    {/*<img src={footerImg}/>*/}
                </div>
                <Footer show={this.props.show} showCustomBottom={this.props.topBg || false}/>
            </>
        )
    }
}

export default Layout
